module.exports = __webpack_public_path__ + "static/img/mingf13.4b111959.png";